module.exports = __webpack_public_path__ + "img/2025-0424-01-01.c6930ed8.png";